export const useStyles = () => {
  return {
    fullAvatarImg: {
      height: '100%',
      position: 'absolute',
      top: '50%',
      left: '-30px',
      transform: 'translateY(-50%)',
    },
  };
};
